module.exports = __webpack_public_path__ + "media/images/t_logo-17148649592ca08266693ff0e7ecbd1a.svg";